import { Link } from 'react-router-dom';

export const CustomLink = ({ to, children, className = '', ...props }) => {
  return (
    <Link
      aria-label={`${to} link`}
      to={to}
      className={`${className}`}
      {...props}
    >
      {children}
    </Link>
  );
};
